/** AS SEEN ON SCRIPT **/

document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '.splide', {
      type   : 'loop',
      perPage: 5,
      perMove: 1,
      pagination: false,
      easing: 'cubic-bezier(0.5, 1, 0.89, 1)',
      autoplay: true,
      interval: 2000,
      autoWidth: true
  } ).mount();
} );

/** FAQS SCRIPT **/

let faqText = document.querySelectorAll('.faq p');
let faqArrow = document.querySelectorAll('.faq-title i');

const faqClick = (n) => {
  if (faqText[n].style.maxHeight == '0px') {
    faqText[n].style.maxHeight = 'none';
    faqArrow[n].style.transform = 'rotate(90deg)';
    console.log('open');
  }

  else {
    faqText[n].style.maxHeight = '0px';
    faqArrow[n].style.transform = 'rotate(0deg)';
    console.log('closed');
  }

};
    